import { gql } from "@apollo/client";

const CatalogContextualFiltersV2_Shared_Query = gql`
  query CatalogContextualFiltersV2_Shared_Query(
    $searchSessionId: String!
    $dosageFormatSort: [DosageFormatSort!]!
    $allergenSort: [AllergenSort!]!
    $populationSort: [PopulationSort!]!
    $thirdPartyCertificationSort: [ThirdPartyCertificationSort!]!
  ) {
    viewer {
      contextualFilters(
        searchSessionId: $searchSessionId
        dosageFormatSort: $dosageFormatSort
        allergenSort: $allergenSort
        populationSort: $populationSort
        thirdPartyCertificationSort: $thirdPartyCertificationSort
      ) {
        forms {
          id
          dosageFormat {
            id
            baseFormat
            variation
          }
          esResultCount
        }
        brands {
          id
          brand {
            id
            name
            logo
          }
          esResultCount
        }
        allergens {
          id
          allergen {
            id
            name
          }
          esResultCount
        }
        demographics {
          id
          population {
            id
            name
          }
          esResultCount
        }
        thirdPartyCertifications {
          id
          thirdPartyCertification {
            id
            name
          }
          esResultCount
        }
        fsTested
      }
    }
  }
`;

export { CatalogContextualFiltersV2_Shared_Query };
